// src/components/learning/YourProgress.js
import { FaChevronRight, FaBook } from "react-icons/fa";
import { Link, useSearchParams } from "react-router-dom";

const LearningProgress = ({ ongoingAverageProgress, modulesLeft }) => {
  const [searchParams] = useSearchParams();
  const categoryId = searchParams.get("category");
  // Anda bisa mengganti nilai ini dengan data dinamis dari props atau state
  // const progressPercentage = "20%";

  return (
    <Link to={`/learn/progress?category=${categoryId}`}>
      <div className="bg-[#CAD2E8] p-5 rounded-lg shadow-[0_2px_4px_2px_rgba(0,0,0,0.1),0_1px_2px_0_rgba(0,0,0,0.2)] w-full mx-auto">
        {/* Bagian Atas: Judul dan Panah */}
        <div class="">
          <div className="flex justify-between items-center">
            <h2 className="text-lg font-semibold text-[#585F72]">
              Your Progress Learning
            </h2>
            <FaChevronRight className="text-[#585F72]" />
          </div>

          {/* Bagian Progress Bar */}
          <div className="mt-4">
            {" "}
            <div className="w-full bg-gray-200 rounded-full h-3 mt-2">
              <div
                className="bg-[#302571] h-3 rounded-full"
                style={{ width: ongoingAverageProgress + "%" }}
              ></div>
            </div>
            <p className="text-xl font-bold text-[#302571]">
              {Number(ongoingAverageProgress).toFixed(2) + "%"}
            </p>
          </div>

          {/* Bagian Keterangan Bawah */}
          <div className="mt-3 flex items-center text-sm text-[#585F72]">
            <FaBook className="mr-2 text-[#585F72]" />
            <span>
              You're {modulesLeft} modules away from earning your certificate
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default LearningProgress;
